<template>
  <div>
    <div class="container">
      <!-- <div class="top-tool">
        <div class="sort">
          <ul>
            <li>
              <el-checkbox-group v-model="selectOptionList" @change="selectOpCartWHChange">
                <el-checkbox v-for="(item, index) in whSelectOptions" :label="item.value" :key="index">{{ item.label }}</el-checkbox>
              </el-checkbox-group>
            </li>
          </ul>
        </div>
      </div> -->
      <el-table class="" ref="multipleTable" border stripe :data="cartList" tooltip-effect="dark"
        @selection-change="cartSelectionChange">
        <el-table-column align="center" label="全选" type="selection" width="55" />
        <el-table-column property="warehouseName" label="供应商" width="180">
          <span slot-scope="scope">{{ scope.row.warehouseUserName ? scope.row.warehouseUserName :
            scope.row.supWarehouseCode }}</span>
        </el-table-column>
        <el-table-column label="图书名称" align="left" prop="">
          <template slot-scope="scope">
            <el-row align="left">
              <el-col :span="8">
                <el-popover placement="right" trigger="hover">
                  <el-image slot="reference" style="width: 50px; height: 50px" :src="scope.row.productImg"
                    fit="cover" />
                  <el-image style="width: 220px; height: 220px" :src="scope.row.productImg" fit="cover" />
                </el-popover>
              </el-col>
              <el-col :span="16" :pull="2">{{ scope.row.productName }}</el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column align="center" label="ISBN" width="180" prop="productSn" />
        <el-table-column label="来源库" align="center" prop="discount" width="80">
          <template slot-scope="scope">
            <div style="color:green;" v-if="scope.row.productSource === '0'">系统库</div>
            <div style="color:saddlebrown;" v-else>供应商自己库</div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="折扣价" prop="vipPrice" width="90" align="center">
          <template slot-scope="scope">
            <div style="color:#F56C6C;">￥{{ scope.row.vipPrice }}</div>
          </template>
        </el-table-column> -->
        <el-table-column label="折扣价" prop="shopPrice" width="90" align="center">
          <template slot-scope="scope">
            <div style="color:#F56C6C;">￥{{ scope.row.shopPrice }}</div>
          </template>
        </el-table-column>
        <el-table-column label="折扣" align="center" prop="discount" width="80" />
        <el-table-column label="定价" prop="marketPrice" width="90" align="center">
          <template slot-scope="scope">
            <div>￥{{ scope.row.marketPrice }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="库存" align="center" prop="stock" width="80" /> -->
        <el-table-column label="数量" align="center" prop="productNumber" width="110">
          <template slot-scope="scope">
            <div class="productNumber-warp">
              <el-input @input="cartGoodsAmountChange($event, scope.row)" v-model="scope.row.productNumber" />
              <div class="quick-button">
                <i class="border el-icon-arrow-up" @click="addAmountCount(scope.row)"></i>
                <i class="border el-icon-arrow-down" @click="subtractAmountCount(scope.row)"></i>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="库存" align="center" prop="stock" width="80" />
        <el-table-column label="小计" width="90" align="center">
          <template slot-scope="scope">
            <div style="color:#F56C6C;">￥{{ (scope.row.shopPrice * scope.row.productNumber).toFixed(2) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" content="删除" placement="top">
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteCartGoods(scope.row)" />
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="cart-option">
        <el-row>
          <el-col :span="3">
            <div class="grid-content bg-purple">
              <el-button type="danger" icon="el-icon-close" @click="clearCart">清空购物车</el-button>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">
              <el-button type="danger" icon="el-icon-delete" @click="batchDeleteCartGoods">删除选中的图书</el-button>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple-light">
              已选择<span class="total-num">{{ selectGoodsList.length }}</span>件图书
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-button type="warning" icon="el-icon-aim" @click="autoDeselectCartGoods"
                title="点击检测库存，并把库存不足的排序到后面">检测库存</el-button>
              <span v-if="nonEnoughStockCount > -1">
                共<span class="total-num">{{ nonEnoughStockCount }}</span>件库存不足
              </span>
            </div>
          </el-col>
          <el-col :span="9" style="text-align: right">
            <div class="grid-content bg-purple-light">
              总价(不含运费)：<span class="total-price">￥{{ cartTotalPrice }}</span>&nbsp;&nbsp;
              <el-button @click="orderconfirm(selectGoodsList.length)" icon="el-icon-s-finance"
                type="danger">去支付</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, putAction, deleteAction } from "../../api/index";
import { selectOptionsList } from "../../utils/index";
import { mapGetters } from "vuex";
export default {
  name: "whcart",
  data() {
    return {
      cartList: [],
      nonEnoughStockCount: -1,
      totalPrice: 0,
      selectGoodsList: [],
      imgurl: "http://img3m7.ddimg.cn/48/5/28998237-1_l_9.jpg",
      url: {
        queryCartWHList: "/cart/wh/queryCartWHList",
        updateWHCart: "/cart/wh/updateCart",
        deleteWHCart: "/cart/wh/deleteCartBatch",
        clearWHCart: "/cart/wh/clearCart",
      },
      whSelectOptions: selectOptionsList(),
      selectOptionList: this.$store.state.selectOptionCartList,
    };
  },
  created() {
    this.getCartList();
  },
  computed: {
    // 总折扣价
    cartTotalPrice() {
      let sum = 0;
      this.selectGoodsList.forEach((item) => {
        sum += item.shopPrice * item.productNumber;
      });
      // 因为要保留小数点后面两位，所以要toFixed(2)
      return sum.toFixed(2);
    },
    // 系统库-折扣价
    cartSystemTotalPrice() {
      let sum = 0;
      this.selectGoodsList.forEach((item) => {
        if(item.productSource === '0'){
          sum += item.shopPrice * item.productNumber;
        }
      });
      // 因为要保留小数点后面两位，所以要toFixed(2)
      return sum.toFixed(2);
    },
    // 供应商自己库-折扣价
    cartWhSelfTotalPrice() {
      let sum = 0;
      this.selectGoodsList.forEach((item) => {
        if(item.productSource === '1'){
          sum += item.shopPrice * item.productNumber;
        }
      });
      // 因为要保留小数点后面两位，所以要toFixed(2)
      return sum.toFixed(2);
    },
    // 原价
    cartTotalMPrice() { 
      let sum = 0;
      this.selectGoodsList.forEach((item) => {
        sum += item.marketPrice * item.productNumber;
      });
      // 因为要保留小数点后面两位，所以要toFixed(2)
      return sum.toFixed(2);
    },
    cartTotalMarketPrice() {
      let sum = 0;
      this.selectGoodsList.forEach((item) => {
        sum += item.marketPrice*1;
      });
      // 因为要保留小数点后面两位，所以要toFixed(2)
      return sum.toFixed(2);
    },
    cartTotalNum() {
      let sum = 0;
      this.selectGoodsList.forEach((item) => {
        sum += item.productNumber*1;
      });
      // 因为要保留小数点后面两位，所以要toFixed(2)
      // return sum.toFixed(2);
      return sum;
    },
    // 系统库总数
    cartSystemTotalNum() {
      let sum = 0;
      this.selectGoodsList.forEach((item) => {
        if(item.productSource === '0'){
          sum += item.productNumber*1;
        }
      });
      // 因为要保留小数点后面两位，所以要toFixed(2)
      // return sum.toFixed(2);
      return sum;
    },
    cartTotalShopPrice() {
      let sum = 0;
      this.selectGoodsList.forEach((item) => {
        sum += item.shopPrice*1;
      });
      // 因为要保留小数点后面两位，所以要toFixed(2)
      return sum.toFixed(2);
    },
    ...mapGetters(["isNaName"]),
  },
  mounted() {
    // this.getCartList();
  },
  updated() {
  },
  methods: {
    selectOpCartWHChange(val) {
      console.log("供应商购物车val :>> ", val, this.selectOptionList);
      this.$store.commit("set_selectOptionCartList", val);
      this.getCartList();
    },
    autoDeselectCartGoods() {
      // console.log(this.$refs.multipleTable.getSelectionRows());
      // let selectGoodsList = this.selectGoodsList;
      // let deselectCount = 0;
      // for (var i = 0; i < selectGoodsList.length; i++) {
      //   if (selectGoodsList[i].productNumber > selectGoodsList[i].stock) {
      //     deselectCount++;
      //     this.$refs.multipleTable.toggleRowSelection(selectGoodsList[i], false);
      //   }
      // }
      // if (deselectCount > 0) {
      //   this.$message.info(
      //     "所选项有" +
      //     deselectCount +
      //     "条已超出最大库存，已自动取消选中"
      //   );
      // } else {
      //   this.$message.success("库存充足，可直接去支付");
      // }

      const enoughArr = this.cartList.filter(item => item.productNumber <= item.stock);
      const nonEnoughArr = this.cartList.filter(item => item.productNumber > item.stock);
      this.nonEnoughStockCount = nonEnoughArr.length;
      this.cartList = [...enoughArr, ...nonEnoughArr];

      this.$refs.multipleTable.toggleAllSelection()
    },
    getCartList() {
      // 设置选择库存区    
      // var sop = getSelectOptionParams1(this.selectOptionList) // 暂时先不用
      var sop = ''
      console.log(sop)
      getAction(this.url.queryCartWHList, {
        whUId: this.$store.state.userInfo.id,
        selectOption: sop,
      }).then((res) => {
        if (res.data.success) {
          this.cartList = res.data.result;
          this.$store.state.shopWHCart = res.data.result;
          window.sessionStorage.setItem("shopWHCart",JSON.stringify(res.data.result));
          // console.log(this.cartList);
          this.checkeds = new Array(this.cartList.length);

          this.$refs.multipleTable.toggleAllSelection()
          // this.selectGoodsList = this.cartList;
        }
      });
    },
    orderconfirm(ordernum) {
      if (ordernum < 1) {
        this.$message.warning("请选择一本图书");
      } else {
        // this.$router.push("/order/confirm");
        let selectGoodsList = this.selectGoodsList;
        /*selectGoodsList.forEach((item) => {
          if (item.productNumber>item.stock){
           return this.$message.error("供应商为"+item.warehouseUserName+",书名为"+item.productName+",ISBN号为"+item.productSn+"的书籍要购买数量大于库存数量,请重新选择!");
          }
        });*/
        for (var i=0;i<selectGoodsList.length;i++){
          if (selectGoodsList[i].productNumber>selectGoodsList[i].stock){
            return this.$message.error("供应商为"+selectGoodsList[i].warehouseUserName+",书名为"+selectGoodsList[i].productName+",ISBN号为"+selectGoodsList[i].productSn+"的书籍要购买数量大于库存数量,请重新选择!");
          }
        }
        let usersId = this.$store.state.userInfo.usersId;
        let cartSystemTotalPrice = this.cartSystemTotalPrice;
        if(0<cartSystemTotalPrice && (!usersId || usersId == '' || usersId.length <= 0)){
          return this.$message.error("您没有绑定支付客户账号，不能选择系统库图书，请重新选择。");
        }
        let cartWhSelfTotalPrice = this.cartWhSelfTotalPrice;

        let cartTotalPrice = this.cartTotalPrice;
        let cartTotalMarketPrice = this.cartTotalMarketPrice;
        let cartTotalShopPrice = this.cartTotalShopPrice;
        let cartTotalNum = this.cartTotalNum;
        let cartSystemTotalNum = this.cartSystemTotalNum;
        let cartTotalMPrice = this.cartTotalMPrice;
        

        this.$router.push({
          path: "/whNewOrder",
          params: {
            selectGoodsList,
            cartTotalPrice,
            cartTotalMPrice,
            cartTotalMarketPrice,
            cartTotalShopPrice,
            cartTotalNum,
            cartSystemTotalNum,
            cartSystemTotalPrice,
            cartWhSelfTotalPrice,
          },
          name: "供应商确认订单",
        });
      }
    },
    // 购物车选择事件（elemenUI表格勾选保存的值）
    cartSelectionChange(val) {
      this.selectGoodsList = val;
      // console.log("this.selectGoodsList===============", this.selectGoodsList);
    },
    // 图书数量文本框改变事件
    cartGoodsAmountChange(e, cartInfo) {
      console.log("e :>> ", e);
      if (e <= 0) {
        cartInfo.productNumber = 1;
        return this.$message.error("图书数量不能小于0");
      } else if (e > cartInfo.stock) {
        cartInfo.productNumber = cartInfo.stock;
        return this.$message.error("加购数量已超出最大库存了！");
      } else {
        this.updateCart(cartInfo);
      }
    },
    // 图书数量加1
    addAmountCount(cartInfo) {
      if (cartInfo.productNumber >= cartInfo.stock) {
        return this.$message.error("加购数量已超出最大库存了！");
      }
      ++cartInfo.productNumber;
      this.updateCart(cartInfo);
    },
    // 图书数量减1
    subtractAmountCount(cartInfo) {
      if (cartInfo.productNumber <= 1) {
        return this.$message.error("图书数量不能小于0");
      }
      --cartInfo.productNumber;
      this.updateCart(cartInfo);
    },
    updateCart(cartInfo) {
      // let formData = Object.assign(cartInfo, values)
      putAction(this.url.updateWHCart, cartInfo).then((res) => {
        if (res.success) {
          this.$message.success("更新成功");
        }
      });
    },
    // 单个删除购物车图书
    deleteCartGoods(cartInfo) {
      this.$confirm("此操作将移除购物车的图书, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // 这里调用接口删除的方法
          deleteAction(this.url.deleteWHCart, { ids: cartInfo.id }).then(
            (res) => {
              this.$message.info(res.data.result);
              this.getCartList();
            }
          );
        })
        .catch((e) => {
          console.log(e);
          this.$message.info("已取消删除");
        });
    },
    // 批量删除购物车图书
    batchDeleteCartGoods() {
      if (this.selectGoodsList.length < 1) {
        this.$message.error("请勾选要移除购物车的图书");
        return;
      }
      this.$confirm("此操作将移除勾选的购物车的图书, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // 这里调用接口删除的方法
          let ids = [];
          this.selectGoodsList.forEach((item) => {
            ids.push(item.id);
          });
          deleteAction(this.url.deleteWHCart, { ids: ids.join(",") }).then(
            (res) => {
              this.$message.info(res.data.result);
              this.getCartList();
            }
          );
        })
        .catch((e) => {
          console.log(e);
          this.$message.info("已取消删除");
        });
    },
    clearCart() {
      getAction(this.url.clearWHCart, {
        whUId: this.$store.state.userInfo.id,
      }).then((res) => {
        if (res.data.success) {
          this.$message.info("已清空购物车，快去选购自己的图书吧！");

          this.getCartList();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.go-to {
  margin: 15px;
  display: flex;
  justify-content: flex-end;
}
.product_b {
  float: left;
  width: 56%;
  height: 100%;
}

.productNumber-warp {
  display: flex;

  input {
    width: 31px;
    height: 31px;
    line-height: 30px;
    padding-left: 10px;
    outline: none;
  }

  .quick-button {
    i {
      display: block;
      width: 30px;
      height: 16px;
      border-left: none;
      text-align: center;
      line-height: 16px;
      cursor: pointer;
    }

    .el-icon-arrow-up {
      border-bottom: none;
    }
  }

  .quick-button i:hover {
    color: #ef001c;
  }
}

.cart-option {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  margin: 0 auto;
  width: 100%;

  .delete {
    margin-left: 20px;
    cursor: pointer;
  }

  .total-num {
    margin: 0 5px;
  }

  .total-price {
    font-size: 24px !important;
    font-weight: 700 !important;
    vertical-align: bottom;
    color: #f56c6c !important;
  }
}


.top-tool {
  line-height: 30px;
  display: flex;
  justify-content: space-between; //两端对齐
  border: 1px solid #cccc;
  border-radius: 4px;
  background-color: #fff;
  color: #303133;
  transition: 0.3s;
  div {
    line-height: 32px;
  }
  .sort {
    ul {
      li {
        float: left;
        margin-left: 10px;
        a {
          color: #303133;
          &:hover {
            color: #409eff;
          }
        }
      }
    }
  }
}
</style>
